// ============================================================================
// SWAHILI TRANSLATIONS - UNITY MODULE
// ============================================================================

export const unityTranslations = {
title: "Umoja unaoleta amani",
    author: "Na Emmanuel",
    subtitle: "Kila dini ina sababu zake, mipaka yetu inatoka katika zamani",
    description: "Moduli ya kutafakari juu ya umoja wa kiroho na amani kati ya desturi",
    
    nav: {
      intro: "Utangulizi",
      religions: "Dini",
      common: "Misingi ya kawaida",
      humility: "Unyenyekevu"
    },

    intro: {
      emmanuelSays: "Emmanuel anasema:",
      ourBordersFromPast: "Mipaka yetu inatoka katika zamani",
      bordersDescription: "Kila dini ina sababu zake. Migawanyiko yetu si mapenzi ya Mungu, bali matunda ya historia, jiografia, utamaduni.",
      divisionWork: "Mgawanyiko, kutengwa kwa vizuizi na mipaka ya hofu, ni kazi ya zamani zetu za hatari.",
      sharedHumanity: "Tulizaliwa katika desturi tofauti, lakini tunashiriki ubinadamu sawa.",
      
      revelationTitle: "Ufunuo unaofungua macho",
      surprisedLearning: "Nilishangaa siku moja kujifunza kwamba Wayahudi pia ni wana wa Mungu.",
      angelMichael: "Kwamba malaika Mikaeli ni mjumbe mkuu kwa Waislamu.",
      jesusNames: "Kwamba Yesu, Isa, Yeshua wanajulikana kwa njia mbalimbali, hata katika imani ya Kikristo.",
      diverseTribes: "Kwa maana kuna makabila mbalimbali, makanisa mbalimbali, familia mbalimbali.",
      sameRealities: "Tunazungumza juu ya ukweli sawa kwa majina tofauti. Hii inapaswa kutukaribia, si kutugawanya.",
      
      respectTitle: "Heshima: msingi wa unyenyekevu, mlinzi wa amani",
      respectFoundation: "Hata kama undugu hauwezekani kwa ukweli, heshima ni msingi wa unyenyekevu, mlinzi wa amani.",
      understandingProcess: "Kuelewa na kuheshimu dini zingine ni mchakato wa unyenyekevu. Haimaanishi kuacha imani yako, bali kukubali kwamba wengine pia wanatafuta ukweli.",
      
      whatBindsUs: "Kinachotuunganisha kweli",
      seekingRelation: "Kila dini inatafuta uhusiano. Kila mtu anatafuta amani.",
      loveOfGod: "Uhusiano huu unaouunganisha wote, ni upendo wa Mungu.",
      universalLink: "Upendo ni kiungo cha ulimwengu kinachopita mipaka yote, lugha zote, desturi zote.",
      
      inclusionTitle: "Ujumuishaji: zaidi ya utofauti wa kidini",
      vastInclusion: "Utofauti wa kidini ni mkubwa, lakini zaidi ya hayo ni ujumuishaji wa wengine pale wanapoitwa na Mungu.",
      respectDifferences: "Heshima kwa tofauti za rangi, jinsia, ujumuishaji unatufanya wanadamu wa kipekee, wanaopendwa na Mungu.",
      jesusCommand: "Yesu alisema: 'Pendaneni.'",
      
      communitySpirit: "Kuachana na roho ya kikabila",
      communityTerror: "Ukabila ni utisho wa chuki iliyofichwa ya uovu. Inabadilisha imani kuwa utambulisho wa kikabila, ukuta unaogawanya, silaha inayoumiza.",
      pridePolitics: "Roho zetu za chama zinatusukuma kwenye siasa za kiburi:",
      prideQuotes: "Nina haki ya kukuumiza. Nina haki tu. Nina haki ya kufanya vita nzuri.",
      watchHeart: "Tahadhari na moyo wa tatizo, mzizi wa uovu wetu wenyewe.",
      refuseDivision: "Tukatae mwelekeo huu unaogawanya ubinadamu kwa jina la Mungu.",
      
      freedomTitle: "Kuwa huru, wafanye wengine huru",
      freedomOthers: "Kuwa huru, lazima tujue jinsi ya kuwafanya wengine huru pia.",
      defendFreedom: "Uhuru wangu wa kuamini una thamani tu ikiwa ninalinda ule wa wote. Kuonea wengine ni kujihukumu mwenyewe kwenye utumwa.",
      
      changeHeartTitle: "Badilisha moyo wako: kuwa taa halisi",
      recognizeDecency: "Tambua kwamba adabu si sawa kwa kila mtu.",
      changeYourself: "Jibadilishe kwanza, hatua kwa hatua. Badilisha moyo wako, geuza maisha yako, kuwa taa halisi.",
      beExample: "Usikojoe kwenye nyasi, kwa maana itakufa... Usiweke sheria zako kwa wengine, bali kuwa mfano hai kwa mabadiliko yako.",
      
      childrenPeaceTitle: "Watoto wetu wataishi kwa amani katika utofauti",
      avoidPursuit: "Epuka kufuatilia maneno kwa maneno.",
      peaceChoice: "Ikiwa tutachagua heshima leo, watoto wetu wa kesho wataishi kwa amani katika utofauti. Amani inaanza na sisi, sasa, katika maneno yetu na matendo yetu.",
      
      discernTitle: "Tambua: mwanadamu au Mungu?",
      manSpeaks: "Mara nyingi, ni moyo wa mwanadamu unazungumza na kugawanya.",
      seeFruits: "Tunaona hilo kwa matunda ya maneno na misemo: wizi, uharibifu, vita. Tahadhari na udanganyifu wa maneno kushindana kwa kiburi chako mwenyewe.",
      
      lookPeaceTitle: "Tazama kwa amani na upendo",
      lookPeaceAll: "Tazama kwa amani kwa wote, tazama kwa upendo wa Mungu kwa wengine.",
      godSpeaks: "Wakati maneno yanaleta amani, upatanisho, umoja: ni Mungu anazungumza. Wakati yanaleta mgawanyiko, chuki, vita: ni kiburi cha mwanadamu.",
      
      watchWordsTitle: "Angalia maneno yetu",
      watchShares: "Angalia mgawanyiko wetu, angalia maneno yetu makali ya hasara kwa wengine.",
      disqualify: "Mabaya haya yanatutoa nje. Matunda ya maneno yetu yanafunua nani anazungumza ndani yetu: Mungu au kiburi chetu wenyewe?",
      
      wisdomMaturityTitle: "Hekima na ukomavu mbele ya asili yetu",
      useScriptures: "Kutumia maandiko (sheria) kuumiza ni tabia yetu, mchakato karibu wa asili na mchezo.",
      hateSin: "Mbele ya asili yetu ya dhambi, tunachukia uovu na watu wanaofanya uovu.",
      separateActs: "Lakini kwa hekima na ukomavu, lazima tugawanye matendo na umaskini wetu wa kibinadamu.",
      compassionNature: "Kutambua asili yetu ya kinyama inayohitaji huruma na neema, huku tukijilinda kulingana na muktadha.",
      
      denounceLeadersTitle: "Walaani viongozi wa kiroho waliooza",
      watchLeaders: "Tahadhari na viongozi wa kiroho au watawala wanaotafuta kuweka siri mwelekeo wao na udanganyifu.",
      noJustice: "Bila haki, hakuna mfano. Bila maarifa, waathirika wengine wanakufa kwa ukimya wetu.",
      silenceComplicity: "Ukimya mbele ya udhalimu ni ushirikiano. Ukweli lazima usemwe kulinda wengine."
    },

    religions: {
      title: "Dini mbalimbali, ubinadamu mmoja",
      intro: "Wakristo, Waislamu, Wayahudi, Wahindu, Mabuddha... na wengi wengine: wote wanatafuta ukweli",
      theirGod: "Mungu wao:",
      theGood: "Wema:",
      theEvil: "Ubaya:",
      theAngels: "Malaika:",
      theUnity: "Umoja:",
      values: "Thamani:",
    commonGoal: "Lengo la Pamoja",
    seekingPeace: "Dini zote zinashiriki lengo moja: kutafuta amani, kuendeleza upendo na kujenga ulimwengu bora. Zaidi ya tofauti zetu, sote tumejiunga katika utafutaji huu wa hekima na mwangaza.",
      
      christianity: {
        name: "Ukristo",
        godText: "Mungu mmoja pekee, Baba Muumba",
        goodText: "Upendo wa jirani, msamaha, amani",
        evilText: "Chuki, ubinafsi, vurugu",
        angelsText: "Wajumbe wa Mungu (Gabrieli, Mikaeli...)",
        unityText: "Mungu mmoja kwa wanadamu wote",
        values: "Upendo,Msamaha,Amani,Unyenyekevu,Haki"
      },
      islam: {
        name: "Uislamu",
        godText: "Allah, wa Pekee na Mwenye Rehema",
        goodText: "Haki, sadaka, amani",
        evilText: "Uonevu, uongo, mgawanyiko",
        angelsText: "Malaika wa nuru (Jibrili, Mikaili...)",
        unityText: "Hakuna mungu isipokuwa Allah",
        values: "Amani,Haki,Sadaka,Heshima,Rehema"
      },
      judaism: {
        name: "Uyahudi",
        godText: "YHWH, wa Milele Pekee",
        goodText: "Haki, huruma, maisha",
        evilText: "Uonevu, uchongezi, chuki",
        angelsText: "Wajumbe wa mbinguni (Malakhim)",
        unityText: "Sikiliza Israeli, wa Milele ni Mmoja",
        values: "Haki,Maisha,Kumbukumbu,Amani,Masomo"
      },
      hinduism: {
        name: "Uhindu",
        godText: "Brahman, ukweli wa juu",
        goodText: "Kutotumia vurugu (ahimsa), wajibu wa haki",
        evilText: "Vurugu, ujinga wa kiroho",
        angelsText: "Devas, viumbe vyema vya mbinguni",
        unityText: "Vyote ni Kimoja katika Brahman",
        values: "Kutotumia_vurugu,Ukweli,Huruma,Usafi,Mwamko"
      },
      buddhism: {
        name: "Ubuddha",
        godText: "Hakuna mungu muumba, lakini heshima kwa kitakatifu",
        goodText: "Huruma, hekima, amani",
        evilText: "Mateso yaliyosababishwa na ujinga",
        angelsText: "Bodhisattvas, viumbe vilivyoamka",
        unityText: "Asili ya Buddha kwa kila mtu",
        values: "Huruma,Hekima,Amani,Kutotumia_vurugu,Kuamka"
      }
    },

    common: {
      title: "Misingi ya kawaida",
      intro: "Wema, Ubaya, Malaika, Mungu Mmoja, Uhusiano, Ujumuishaji: kinachounganisha ubinadamu",
      
      goodTitle: "Wema",
      goodDescription: "Dini zote zinafundisha upendo, haki na huruma",
      goodExamples: "Penda jirani yako kama wewe mwenyewe|Fanya wema bila kubagua|Linda dhaifu na walioonewa|Sema ukweli kwa fadhili|Shiriki ulicho nacho",
      
      evilTitle: "Ubaya",
      evilDescription: "Zote zinakataa vurugu, uongo na uonevu",
      evilExamples: "Kuua bila haki|Kuiba na kunyonya|Kusema uongo na kuchongeza|Kudharau na kudhalilisha|Kugawanya na kuchukia",
      
      angelsTitle: "Malaika na Viumbe vya Kiroho",
      angelsDescription: "Karibu zote zinakubali wajumbe vyema wa mbinguni",
      angelsExamples: "Malaika wajumbe wa Mungu|Waongozi wa kiroho|Viumbe vya nuru|Walinda wa mbinguni|Bodhisattvas na Devas",
      
      godTitle: "Mungu Mmoja (au Ukweli wa Juu)",
      godDescription: "Wengi wanaamini chanzo kimoja, muumba au ukweli wa mwisho",
      godExamples: "Ukristo, Uislamu, Uyahudi: Mungu Mmoja|Uhindu: Brahman, Mmoja wa juu|Ubuddha: Asili ya Buddha ya ulimwengu|Wote wanatafuta ukweli wa mwisho|Wote wanatamani umoja na amani",
      
      relationTitle: "Uhusiano na Amani",
      relationDescription: "Kinachounganisha kweli dini zote na wanadamu wote",
      relationExamples: "Kila dini inatafuta uhusiano na umungu|Kila mtu anatafuta amani|Uhusiano huu unaouunganisha wote, ni upendo wa Mungu|Upendo ni kiungo cha ulimwengu|Amani ni shauku yetu ya pamoja",
      
      inclusionTitle: "Ujumuishaji: Wanaopendwa na Mungu",
      inclusionDescription: "Utofauti wa kidini ni mkubwa, lakini ujumuishaji ni zaidi",
      inclusionExamples: "Ujumuishaji wa wengine pale wanapoitwa na Mungu|Heshima kwa tofauti za rangi|Heshima kwa tofauti za jinsia|Ujumuishaji unatufanya wanadamu wa kipekee, wanaopendwa na Mungu|Yesu alisema: 'Pendaneni'",
      
      finalQuote: "Nilishangaa siku moja kujifunza kwamba Wayahudi pia ni wana wa Mungu, kwamba malaika Mikaeli ni mjumbe mkuu kwa Waislamu, kwamba Yesu, Isa, Yeshua wanajulikana kwa njia mbalimbali hata katika imani ya Kikristo. Kwa maana kuna makabila mbalimbali, makanisa mbalimbali, familia mbalimbali.",
      finalQuote2: "Tunazungumza juu ya ukweli sawa kwa majina tofauti.",
      quoteAuthor: "Emmanuel, Umoja unaoleta amani"
    },

    humility: {
      title: "Hatua 7 kuelekea unyenyekevu na amani",
      intro: "Mchakato wa kupita ukabila na kuwa taa halisi",
      
      step: "Hatua",
      action: "Tendo:",
      
      step1Title: "Kutambua: mipaka yetu inatoka katika zamani",
      step1Description: "Mgawanyiko, kutengwa kwa vizuizi na mipaka ya hofu, ni kazi ya zamani zetu za hatari. Migawanyiko yetu si mapenzi ya Mungu.",
      step1Action: "Kukubali kwamba desturi yangu ni yangu tu, na mimi ni sehemu ya utofauti unaotakiwa na Mungu",
      
      step2Title: "Heshima: msingi wa unyenyekevu, mlinzi wa amani",
      step2Description: "Hata kama undugu hauwezekani kwa ukweli, heshima ni msingi.",
      step2Action: "Kuheshimu imani zote, hata bila kuelewa kila kitu",
      
      step3Title: "Kuelewa bila kuhukumu",
      step3Description: "Leo, kuelewa wengine ni mchakato muhimu wa unyenyekevu.",
      step3Action: "Kusikiliza kweli wengine wanaamini nini, bila kuhukumu",
      
      step4Title: "Jibadilishe kwanza: kuwa taa halisi",
      step4Description: "Kutambua kwamba adabu si sawa kwa kila mtu. Badilisha moyo wako hatua kwa hatua, geuza maisha yako, kuwa nuru halisi.",
      step4Action: "Kutoweka sheria zangu kwa wengine, bali kuwa mfano hai kwa mabadiliko yangu",
      
      step5Title: "Kuachana na roho ya kikabila",
      step5Description: "Roho zetu za chama zinatusukuma kwenye siasa za kiburi: 'Nina haki ya kukuumiza, nina haki tu.' Tahadhari na moyo wa tatizo, mzizi wa uovu wetu wenyewe.",
      step5Action: "Kukataa hotuba za mgawanyiko katika jamii yangu mwenyewe",
      
      step6Title: "Kuwa huru, wafanye wengine huru",
      step6Description: "Uhuru wangu unategemea ule ninaowapa wengine.",
      step6Action: "Kulinda uhuru wa dhamiri wa wote, si wangu tu",
      
      step7Title: "Epuka kufuatilia maneno kwa maneno",
      step7Description: "Kutokujibu chuki kwa chuki, matukano kwa matukano.",
      step7Action: "Chagua amani ili watoto wetu waishi kwa amani katika utofauti",
      
      discernFruits: "Tambua kwa Matunda",
      humanHeart: "Moyo wa mwanadamu unaogawanya",
      lookGodLove: "Tazama kwa upendo wa Mungu",
      watchOurWords: "Angalia Maneno Yetu",
      
      prideFruits: "Matunda ya kiburi cha kibinadamu",
      prideFruitsList: "Roho ya chama: \"Niko sahihi, kipindi\"|Siasa za kiburi: \"Nina haki ya kukuumiza\"|Kutumia maandiko kuumiza (mchakato wa ujanja)|Kuchukia watu (si matendo tu)|Viongozi wa kiroho wanaficha upotovu na udanganyifu wao|Ukimya wa ushirika mbele ya udhalimu|Mgawanyiko na vita|Chuki iliyojificha kama utauwa|Wizi na uharibifu|Udanganyifu kwa ajili ya kiburi|Dharau na vurugu",
      
      godFruits: "Matunda ya upendo wa Mungu",
      godFruitsList: "Kutenganisha matendo na mtu kwa hekima|Huruma kwa umaskini wetu wa kibinadamu|Neema huku tukijilinda kulingana na mazingira|Kukemea udhalimu kulinda wengine|Kusema ukweli kwa ujasiri|Amani kwa wote|Upendo bila ubaguzi|Upatanisho na umoja|Unyenyekevu na heshima|Uhuru kwa wote",
      
      finalQuote: "Hata kama undugu hauwezekani kwa ukweli, heshima ni msingi wa unyenyekevu, mlinzi wa amani. Epuka kufuatilia maneno kwa maneno, na watoto wetu wa kesho wataishi kwa amani katika utofauti.",
      author: "Emmanuel"
    },

    footer: {
      quote: "Heshima ni msingi wa unyenyekevu, mlinzi wa amani. Watoto wetu wataishi kwa amani katika utofauti ikiwa tutachagua heshima leo.",
      author: "Emmanuel, Umoja unaoleta amani"
    }
};

export default unityTranslations;
